import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getMobile } from "../../store/actions/mobiles_action";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/mobiles_enum";
import SingleView from "../../components/common/SingleView";
const ViewMobile = ({ getMobile, match, mobile: { loading, mobile } }) => {
  useEffect(() => {
    getMobile(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!loading ? (
          mobile && (
            <SingleView
              data={mobile}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={mobile.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ mobile: state.mobile });

const mapDispatchToProps = { getMobile };

export default connect(mapStateToProps, mapDispatchToProps)(ViewMobile);
